import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6938484e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "c-sidebar-candidate sticky xl:w-1/3 min-h-full",
  "aria-label": "Sidebar"
}
const _hoisted_2 = {
  class: "w-full h-full block md:w-auto border-r border-neutral-light",
  id: "sidebar-candidates"
}
const _hoisted_3 = { class: "c-sidebar-candidate__return py-5 border-b border-neutral-light" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase" }, "Voltar", -1))
const _hoisted_6 = { class: "c-sidebar-candidate__info-candidate" }
const _hoisted_7 = { class: "px-5 md:px-10 py-5 inline-flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "c-sidebar-candidate__image w-28 h-28 rounded-full ring-4 ring-primary-base overflow-hidden"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "c-sidebar-candidate__infos ml-5" }
const _hoisted_11 = { class: "text-primary-base font-bold text-xl" }
const _hoisted_12 = { class: "text-xs font-light text-primary-base" }
const _hoisted_13 = { class: "flex justify-start mt-3" }
const _hoisted_14 = {
  key: 0,
  class: "bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
}
const _hoisted_15 = {
  key: 1,
  class: "bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
}
const _hoisted_16 = {
  key: 2,
  class: "bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
}
const _hoisted_17 = { class: "sm:px-10 px-5" }
const _hoisted_18 = { class: "inline-flex text-center w-full" }
const _hoisted_19 = { class: "py-3 text-sm w-1/2 font-medium text-white bg-primary-base rounded-l-full border" }
const _hoisted_20 = { class: "text-base font-bold" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base font-light" }, "Partido", -1))
const _hoisted_22 = { class: "py-3 text-sm w-1/2 font-medium text-primary-base bg-secondary-base rounded-r-full border" }
const _hoisted_23 = { class: "text-base font-bold" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base font-light" }, "Número", -1))
const _hoisted_25 = { class: "c-sidebar-candidate__cards sm:px-10 px-5 py-5 grid grid-cols-1 gap-5" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Resumo do perfil")
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-light text-base text-neutral-baseMedium" }, " Idade ", -1))
const _hoisted_29 = { class: "font-bold text-base text-primary-base" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-light text-base text-neutral-baseMedium" }, " Gênero ", -1))
const _hoisted_32 = { class: "font-bold text-base text-primary-base" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-light text-base text-neutral-baseMedium" }, " Cor/Raça ", -1))
const _hoisted_35 = { class: "font-bold text-base text-primary-base" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-light text-base text-neutral-baseMedium" }, " Escolaridade ", -1))
const _hoisted_37 = { class: "font-bold text-base text-primary-base" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Histórico de candidaturas")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconCandidate = _resolveComponent("IconCandidate")!
  const _component_CardInfo = _resolveComponent("CardInfo")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'CandidateList' },
          class: "text-primary-base text-xl font-bold rounded-lg sm:px-8 px-4 py-2 text-center inline-flex items-center mr-2 hover:underline"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          ($setup.currentCandidate.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  class: "w-full rounded-full",
                  src: $setup.currentCandidate.image,
                  alt: "Candidato"
                }, null, 8, _hoisted_9)
              ]))
            : (_openBlock(), _createBlock(_component_IconCandidate, {
                key: 1,
                class: "w-28 h-28 rounded-full p-1 ring-4 ring-primary-base"
              })),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h2", _hoisted_11, _toDisplayString($setup.currentCandidate.ballot_name), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString($setup.currentCandidate.role), 1),
            _createElementVNode("div", _hoisted_13, [
              ($setup.currentCandidate.status === 'APTO')
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Candidatura apta"))
                : ($setup.currentCandidate.status === 'INAPTO')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Candidatura inapta"))
                  : ($setup.currentCandidate.status === 'CADASTRADO')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Aguardando julgamento"))
                    : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, _toDisplayString($setup.currentCandidate.party_abbreviation), 1),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString($setup.currentCandidate.number), 1),
              _hoisted_24
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_CardInfo, null, {
          title: _withCtx(() => [
            _hoisted_26
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("p", _hoisted_29, _toDisplayString($setup.currentCandidate.age), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("p", _hoisted_32, _toDisplayString($setup.currentCandidate.gender), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("p", _hoisted_35, _toDisplayString($setup.currentCandidate.ethnicity), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_36,
              _createElementVNode("p", _hoisted_37, _toDisplayString($setup.currentCandidate.education), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_CardInfo, null, {
          title: _withCtx(() => [
            _hoisted_38
          ]),
          content: _withCtx(() => [
            _createVNode(_component_Timeline, {
              data: $setup.currentCandidate.election_history
            }, null, 8, ["data"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}